<template>
  <button
    v-if="asset"
    class="deck-asset-row-component"
    @click="$emit('card-row-clicked', card)"
  >
    <bookmark-button
      class="bookmark-button"
      :asset-name="asset.assetType"
      :bookmarkable-type="'Attachment'"
      :bookmarkable-id="asset.id"
      :source="bookmarkSource"
    />
    <img
      v-if="thumbnailUrl"
      :src="thumbnailUrl"
      alt=""
      class="thumbnail"
    />
    <div
      v-else
      class="thumbnail fallback"
    >
    </div>
    <label-text :size="'sm'">
      {{ asset.assetTitle || card.title }}
    </label-text>
    <div class="action-container">
      <div
        v-if="asset.duration"
        :class="['duration', {'in-progress': inProgress}]"
        v-html="durationText"
      />
      <div class="view">
        <template v-if="showPlay">
          <icon
            v-if="inProgress"
            name="play-filled"
            class="icon"
            variant="mastery"
          />
          <icon
            v-else
            name="play-outline"
            class="icon"
            variant="mastery"
          />
        </template>
        <icon
          v-else
          name="arrow"
          class="icon"
          variant="mastery"
        />
      </div>
    </div>
  </button>
</template>

<script>
import BookmarkButton from '@components/singletons/bookmarkButton';
import Icon from '@components/singletons/icon';
import LabelText from '@/components/ui/label-text.vue';


import Attachment from '@/classes/attachment';
import CardMixin from '@/mixins/card';

export default {
  name: 'DeckAssetRow',
  components: { BookmarkButton, Icon, LabelText },
  mixins: [CardMixin],
  props: {
    asset: {
      type: Object,
    },
    card: {
      type: Object,
    },
    deck: {
      type: Object,
    },
  },
  computed: {
    bookmarkSource() {
      return { type: 'Card', id: this.card?.id };
    },
    durationText() {
      if (this.inProgress) {
        return `${this.formatDuration(this.timeRemaining)} <span class='remaining-text'>Remaining</span>`;
      }
      return this.asset.duration;
    },
    imageAttachmentId() {
      return this.card.featuredImageId || '';
    },
    imageAttachment() {
      return this.$store.getters['attachments/get'][this.imageAttachmentId] || {};
    },
    inProgress() {
      if (this.attachmentState) {
        return this.timeRemaining > 0 && !this.completed;
      }
    },
    showPlay() {
      if (this.asset.assetType === 'Attachment') {
        return this.asset.mediaType !== 'image' && this.asset.mediaType !== 'biodigital';
      }
    },
    thumbnailUrl() {
      if (this.imageAttachment.url) {
        return this.imageAttachment.url;
      }
      if (this.asset) {
        const attachment = this.$store.getters['attachments/get'][this.asset.displayAttachmentId];
        return attachment?.smallThumbnail;
      }
    },
  },
  methods: {
    formatDuration(duration) {
      return Attachment.formatDuration(duration);
    },
  },
};
</script>

<style lang="scss" scoped>
.deck-asset-row-component {
  align-items: center;
  background: transparent;
  border-top: 1px solid #E5E5E5;
  display: flex;
  padding: 20px;
  text-align: left;
  width: 100%;
  &:last-of-type {
    border-bottom: 1px solid #E5E5E5;
  }

  .thumbnail {
    height: 48px;
    margin: 0 16px;
    object-position: center;
    object-fit: cover;
    width: 48px;
  }

  .action-container {
    display: flex;
    align-items: center;
    flex-direction: column-reverse;
    min-width: rem-calc(40);
    margin-left: auto;

    .view {
      margin-left: 0;
      text-align: center;

      img {
        height: rem-calc(20);
        width: rem-calc(20);
        margin-bottom: rem-calc(5)
      }
      .icon-arrow {
        height: rem-calc(15);
        width: rem-calc(15);
      }
    }

    .duration {
      font-size: rem-calc(14);
      text-align: right;
      color: #a2a2a5;
      margin-right: 0;

      &.in-progress {
        font-weight: $semi-bold;
        color: #000000;
      }

      /deep/ .remaining-text {
        display: none;
      }
    }
  }

  &:hover {
    background-color: #F1F4F8;
  }
}
</style>
